import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { createFileViews } from '../Literature/utils';

const Container = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
`;

const SectionWrap = styled.div`
  display: ${p => (p.show ? 'block' : 'none')};
  width: 100%;
`;

const AccordionTabSection = ({ sections, active }) => (
  <Container>
    {sections.map(({ literature }, index) => (
      <SectionWrap key={index} show={active === index}>
        {createFileViews(literature)}
      </SectionWrap>
    ))}
  </Container>
);

AccordionTabSection.propTypes = {
  sections: PropTypes.array,
  active: PropTypes.number
};
export default AccordionTabSection;
